<template>
	<div class="form">
    <van-cell-group inset>
      <van-cell title="申请人信息" value="" />
      <van-cell>
        <template #title>
          <van-field v-model="realname" placeholder="请填写真实姓名">
            <template #label>
              <span class="title_important">申请人</span>
            </template>
          </van-field>
        </template>
      </van-cell>
      <van-cell>
        <template #title>
          <van-field v-model="mobile" type="tel" placeholder="请填写手机号">
            <template #label>
              <span class="title_important">手机号</span>
            </template>
          </van-field>
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group inset>
      <van-cell title="活动信息" value="" />
      <van-cell>
        <template #title>
          <van-field v-model="meetingname" placeholder="请填写会议名称">
            <template #label>
              <span class="title_important">会议名称</span>
            </template>
          </van-field>
        </template>
      </van-cell>
      <van-cell is-link arrow-direction="down" @click="dateFn('start')">
        <template #title>
          <van-field v-model="starttime" readonly placeholder="请选择会议开始时间">
            <template #label>
              <span class="title_important">开始时间</span>
            </template>
          </van-field>
        </template>
      </van-cell>
      <van-cell is-link arrow-direction="down" @click="dateFn('end')">
        <template #title>
          <van-field v-model="endtime" readonly placeholder="请选择会议结束时间">
            <template #label>
              <span class="title_important">结束时间</span>
            </template>
          </van-field>
        </template>
      </van-cell>
      <van-cell is-link arrow-direction="down" @click="startSite">
        <template #title>
          <van-field v-model="address" readonly rows="2" type="textarea" placeholder="请选择会议地址">
            <template #label>
              <span class="title_important">地点</span>
            </template>
          </van-field>
        </template>
      </van-cell>
      <van-cell>
        <template #title>
          <p class="van-field__label">备注</p>
          <van-field
            class="textarea"
            v-model="remark"
            rows="4"
            label=""
            type="textarea"
            maxlength="200"
            placeholder="请输入留言"
            show-word-limit
          />
        </template>
      </van-cell>
    </van-cell-group>
    <div class="footer footerIOS">
      <van-button type="primary" block color="linear-gradient(90deg, #FB6E38 0%, #FE9B4B 100%)" @click="submit">提交</van-button>
      <div class="h"></div>
    </div>
    <van-popup v-model="timeShow" position="bottom" :style="{ height: '46%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        title="选择完整时间"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="handlePickerConfirmDate"
        @cancel="timeShow = false"
        :columns-order="['year', 'month', 'day', 'hour', 'minute']"
      />
    </van-popup>
    <div v-if="showMap">
      <van-popup v-model="showMap" position="right" :style="{ height: '100%',width:'100%' }">
        <qq-map :map-key="mapKey" :key-name="keyName" :lat="latitude" :lng="longitude" @callback="callback" @hideMap="showMap=false"></qq-map>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { isWeixin, fenxiang } from '../../assets/common/js/config'
import wx from "weixin-js-sdk";
import QqMap from "../common/Qqmap.vue";
export default {
  name: "applymeeting",
  components: {
    QqMap
  },
  data () {
    return {
      realname: '',
      mobile: '',
      meetingname: '',
      starttime: '',
      endtime: '',
      timetype: '',
      timeShow: false,
      currentDate: new Date(),
      minDate: new Date(),
      maxDate: new Date(new Date().getTime() + 946771200000),
      province: '',
      city: '',
      area: '',
      address: '',
      lng: '',
      lat: '',
      remark: '',
      showMap: false,
      mapKey: "526BZ-5VR6U-26ZVZ-42EA5-66IWZ-UFBX5",
      keyName: "mysite",
      latitude: "",
      longitude: "",
      sitepcq: ""
    }
  },
  mounted () {
	  if (isWeixin()) {
		  fenxiang({path: 'meetingloginin'})
	  }
  },
  methods: {
    dateFn (type) {
      this.timeShow = true
      this.timetype = type
    },
    handlePickerConfirmDate (v) {
      if (this.timetype == 'end') {
        if (new Date(v).getTime() <= new Date(this.starttime.replace(/-/g, '/')).getTime()) {
          this.$toast('结束大于需要大于开始时间，请重新选择')
          return
        }
      } else {
        if (new Date(this.endtime.replace(/-/g, '/')).getTime() <= new Date(v).getTime()) {
          this.$toast('开始时间需要小于结束时间，请重新选择')
          return
        }
      }
      console.log(v, new Date(v).getFullYear(),
        new Date(v).getMonth()+1,
        new Date(v).getDate(),
        new Date(v).getHours(),
        new Date(v).getMinutes(),
        new Date(v).getSeconds())
      let year = new Date(v).getFullYear(),
        month = new Date(v).getMonth()+1,
        date = new Date(v).getDate(),
        hours = new Date(v).getHours(),
        minutes = new Date(v).getMinutes(),
        seconds = new Date(v).getSeconds()
      this[this.timetype + 'time'] = year + '-' + month + '-' + date + ' '
        + (hours > 10 ? hours : '0' + hours) + ':' + (minutes > 10 ? minutes : '0' + minutes)  + ':'
        + (seconds > 10 ? seconds : '0' + seconds)
      this.timeShow = false
    },
    // 地图选择回调
    callback(mapData) {
      this.showMap = false;
      if (typeof mapData.poiaddress == "undefined") {
        return;
      }
      this.discern(mapData.poiaddress);
    },
    discern(site) {
      let url = this.$ajax.initAddress_URL+"?text=" + site
      this.$customRequestAjax(url).then(res => {
        this.province = res.data.province
        this.city = res.data.city
        this.area = res.data.county
        this.address = res.data.province
          + res.data.city
          + res.data.county
          + res.data.town
          + res.data.detail;
        this.lng = res.data.lng
        this.lat = res.data.lat
      });
    },
    startSite() {
      if (!isWeixin()) {
        this.$toast('请在微信使用此功能')
      }
      let that = this;
      wx.getLocation({
        type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function(res) {
          that.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          that.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
          // var speed = res.speed; // 速度，以米/每秒计
          // var accuracy = res.accuracy; // 位置精度
          that.showMap = true;
        }
      });
    },
    submit () {
      if (!this.realname) {
        this.$toast('申请人不能为空')
        return
      } else if (!this.mobile) {
        this.$toast('手机号不能为空')
        return
      } else if (!(/^1[3456789]\d{9}$/.test(this.mobile))) {
        this.$toast('手机号码有误，请重填')
        return
      } else if (!this.meetingname) {
        this.$toast('会议名称不能为空')
        return
      } else if (!this.starttime) {
        this.$toast('开始时间不能为空')
        return
      } else if (!this.endtime) {
        this.$toast('结束时间不能为空')
        return
      } else if (!this.address) {
        this.$toast('地点不能为空')
        return
      }
      var url = this.$ajax.saveMeetinginfo_URL, data = {
        realname: this.realname,
        mobile: this.mobile,
        meetingname: this.meetingname,
        starttime: this.starttime,
        endtime: this.endtime,
        province: this.province,
        city: this.city,
        area: this.area,
        address: this.address,
        lng: this.lng,
        lat: this.lat,
        remark: this.remark,
        loginmobile: sessionStorage.getItem('meetinglogin_mobile') ? sessionStorage.getItem('meetinglogin_mobile') : ''
      }
      this.$customRequestAjax.post(url, data).then(res => {
        if (res.data.code == 200) {
          this.$toast(res.data.msg)
          setTimeout(() => {
            this.$router.push('/meetingdetail?meetingid=' + res.data.meetingid)
          }, 500)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/common/css/createmeeting";
  .form {
    padding-bottom: 0.9rem;
  }
  .van-cell-group--inset {
    margin-top: 0.1rem;
    padding: 0.05rem 0;
  }
  .textarea {
    margin-top: 0.1rem;
    border: 0.005rem solid #D8D8D8;
    padding: 0.09rem;
  }
  .footer {
    background: #ffffff;
    padding: 0.1rem 0.15rem;
    position: fixed;
    bottom: 0;
    width: 100%;
    .van-button--primary {
      border-radius: 0.25rem;
    }
    .h {
      height: 0.1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/createmeeting/applymeeting.vue